import React, { useState, useEffect } from 'react';
import { X, Mail, Zap, Gift } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'se_popup_dismissed';
const DELAY_MS = 2 * 60 * 1000; // 2 minutes

export default function PromoPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [code, setCode] = useState('');

  useEffect(() => {
    // Ne pas afficher si déjà fermé/validé
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, 'dismissed');
    setVisible(false);
  }

  async function submit(e) {
    e.preventDefault();
    if (!email || !email.includes('@')) { toast.error('Email invalide'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${BACKEND}/api/promo/email-capture`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const d = await res.json();
      if (res.ok) {
        setCode(d.code);
        setDone(true);
        localStorage.setItem(STORAGE_KEY, 'captured');
        toast.success('Code envoyé dans votre boîte mail !');
      } else {
        toast.error(d.detail || 'Erreur');
      }
    } catch { toast.error('Erreur réseau'); }
    setLoading(false);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)' }}
      onClick={e => { if (e.target === e.currentTarget) dismiss(); }}
    >
      <div
        className="w-full max-w-sm rounded-3xl overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #0B1E20 0%, #1a3a3d 100%)',
          border: '1px solid rgba(212,175,55,0.3)',
          boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
        }}
      >
        {/* Header */}
        <div className="relative p-6 pb-0">
          <button onClick={dismiss}
            className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center"
            style={{ background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.5)' }}>
            <X size={14} />
          </button>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center"
              style={{ background: 'rgba(212,175,55,0.15)' }}>
              <Gift size={22} style={{ color: '#D4AF37' }} />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-wider" style={{ color: '#D4AF37' }}>Offre exclusive</p>
              <p className="text-xl font-bold" style={{ color: '#FFFFFF' }}>-5% sur votre 1ère commande</p>
            </div>
          </div>
          <p className="text-sm mb-5" style={{ color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>
            Entrez votre email et recevez instantanément votre code de réduction personnel.
          </p>
        </div>

        <div className="px-6 pb-6">
          {done ? (
            <div className="text-center py-4">
              <div className="text-3xl mb-2">🎉</div>
              <p className="font-bold text-lg mb-1" style={{ color: '#D4AF37' }}>Votre code : <span style={{ letterSpacing: 2 }}>{code}</span></p>
              <p className="text-xs mb-4" style={{ color: 'rgba(255,255,255,0.5)' }}>Code envoyé à {email}</p>
              <button onClick={dismiss}
                className="px-6 py-2.5 rounded-xl text-sm font-bold"
                style={{ background: '#D4AF37', color: '#0B1E20' }}>
                Utiliser mon code →
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div className="relative">
                <Mail size={15} className="absolute left-3.5 top-1/2 -translate-y-1/2" style={{ color: 'rgba(255,255,255,0.3)' }} />
                <input
                  type="email" placeholder="votre@email.fr" value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl text-sm"
                  style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)', color: '#FFFFFF', outline: 'none' }}
                  required
                />
              </div>
              <button type="submit" disabled={loading}
                className="w-full py-3 rounded-xl font-bold text-sm flex items-center justify-center gap-2"
                style={{ background: '#D4AF37', color: '#0B1E20' }}>
                <Zap size={15} />
                {loading ? 'Envoi...' : 'Recevoir mon code -5%'}
              </button>
              <p className="text-center text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}>
                Pas de spam · 1 email · Désabonnement en 1 clic
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
